module.exports = __webpack_public_path__ + "img/commonly.51053b42.png";